'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Tooltip = require('@sitebase/ui-kit/es/Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _FieldWrapper = require('../FieldWrapper');

var _FieldWrapper2 = _interopRequireDefault(_FieldWrapper);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Cvv component
 * @param {CvvPropsType} param0 The field props
 * @returns {React.Element<*>} React element
 */
var Cvv = function Cvv(_ref) {
  var name = _ref.name,
      normalize = _ref.normalize,
      validation = _ref.validation,
      tabIndex = _ref.tabIndex,
      hintText = _ref.hintText,
      placeholder = _ref.placeholder,
      labelText = _ref.labelText;
  return _react2.default.createElement(
    'div',
    { className: 'qd-cvv' },
    _react2.default.createElement(
      'div',
      { className: 'qd-cvv-label' },
      _react2.default.createElement(
        'span',
        { className: 'qd-cvv-label--text' },
        labelText
      ),
      _react2.default.createElement(
        'div',
        { className: 'qd-cvv-label--tooltip' },
        _react2.default.createElement(
          _Tooltip2.default,
          { tip: placeholder, position: 'left', trigger: 'click' },
          _react2.default.createElement(
            'div',
            { className: 'qd-cvv-label--tooltip-icon' },
            _react2.default.createElement(
              'span',
              { className: 'qd-cvv-label--tooltip-icon-text' },
              '?'
            )
          )
        )
      )
    ),
    _react2.default.createElement(_FieldWrapper2.default, {
      name: name,
      type: 'password',
      normalize: normalize,
      validate: validation,
      tabIndex: tabIndex,
      hintText: hintText,
      placeholder: placeholder,
      inputmode: 'numeric'
    })
  );
};

exports.default = Cvv;